const initialState = {
    showTestDriveForm: false,
    showMakeAnOffer: false,
    offerPrice: '',
    makeAnOfferSuccess: false,
    successmessage: false,
    successData: {}
};

const formData = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_FORM_STATE':
            return {...state, ...action.data};
        case 'GET_HP_DATA_FAILURE':
            return Object.assign([],state, []);
        default:
            return state;
    }
};

export default formData;


// WEBPACK FOOTER //
// ../q-cars/src/redux/reducers/form.js